<template>
	<div class="view-index-v" v-if="mediaLength" :style="{'--img-count': mediaLength}">
		<div class="rotation-poster">
			<div class="container" :style="{left: swiper.offset, transition: `${swiper.ition}s`}">
				<template v-for="(item, idx) in settingData.mediaLst">
					<div class="img-item" :key="idx" @click="onPosterClick(item)"
						:style="{backgroundImage: 'url('+item.coverUrlV+')'}"
						@touchstart="handleTouchStart" @touchend="handleTouchEnd">
						<video v-if="item.videoUrlV" :id="`poster-video-player${idx}`" muted :autoplay="false" 
							@ended="onVideoEnded(idx)" @loadedmetadata="onVideoLoaded(idx)">
							<source :src="item.videoUrlV" type="video/mp4" />
						</video>
						<div class="single-line link-txt">{{item.linkTxt}}</div>
					</div>
					<!-- <img class="img-item" v-else :src="item.coverUrlV" :key="idx"
						 alt="" @click="onPosterClick(item)"> -->
					
				</template>
				
			</div>
			<!-- <div class="menu-list">
				<div class="menu-item inline-column" v-for="(item, idx) in settingData.mediaLst" :key="idx"
					:class="{'actived': swiper.imgShow == idx}" @click="onclickMenuClick(idx)"
					:style="{left: (322 * idx) + 'px' }">
					<div class="menu-item-txt three-lines">
						{{item.linkTxt}}
					</div>
				</div>
				<div class="menu-item-bg" :style="itemBgStyle"></div>
			</div> -->
			<div class="swiper-wrapper inline-between">
				<div class="swiper-item" v-for="(item, idx) in settingData.mediaLst" :key="idx"
					@click="throttle(changeFun, idx)">
					<div class="swiper-item-inner">
						<div class="progress" :class="{'actived': swiper.imgShow == idx}"
							:style="{width: getSwiperProgress(idx)}"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="product-list">
			<div class="inline-start product-caption">
				<img class="list-icon" src="~@/assets/list-icon.png" />
				<div class="inline-column caption">
					<span class="zh">产品与服务</span>
					<span class="en">PRODUCTS AND SERVICES</span>
				</div>
			</div>
			<div class="inline-between main-containner">
				<div class="cat-list-container">
					<div class="cat-list">
						<div class="menu-item-bg" :style="productCatBgStyle"></div>
						<div class="menu-item" v-for="(item, idx) in productCatLst" :key="idx"
							 @click="onclickCatClick(idx)">
							{{item.categoryName}}
						</div>
					</div>
				</div>
				<div class="inline-between product-list-container" v-if="bigProduct">
					<div class="product-item big-product" @click="onProductItemClick(bigProduct.id)">
						<img :src="bigProduct.coverImgUrl" class="product-img" />
						<div class="inf-container">
							<div class="name single-line">{{bigProduct.productName}}</div>
							<div class="profile single-line">{{bigProduct.productProfile}}</div>
						</div>
					</div>
					<div class="small-product-list">
						<div class="product-item sall-product-item" v-for="(item, idx) in smallProductList" 
							:key="idx" @click="onProductItemClick(item.id)">
							<img :src="item.coverImgUrl" class="product-img" />
							<div class="inf-container">
								<div class="name single-line">{{item.productName}}</div>
								<div class="profile single-line">{{item.productProfile}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'IndexV',
		mixins: [IndexMixin],
		components: {

		},
		data() {
			return {
				swiperProgress: [],
				catBgLeft: 0,
				catBgWidth: 0,
				productLstRect: undefined,
				catDomRects: []
			}
		},
		watch: {
			'swiper.imgShow': {
				immediate: true,
				handler(nVal, oVal) {
					if(oVal != undefined) {
						this.$set(this.swiperProgress, oVal, '0%');
					}
					this.$set(this.swiperProgress, nVal, '0%');
					setTimeout(() => {
						this.$set(this.swiperProgress, nVal, '100%');
					} ,500)
				}
			},
			scaleRate: {
				handler(nVal, oVal) {
					if(this.isLoaded) this.onProductCatLoaded();
				}
			}
		},
		computed: {
			...mapGetters(["scaleRate"]),
			itemBgStyle() {
				return {
					left: (322 * this.swiper.imgShow) + 'px'
				}
			},
			productCatBgStyle() {
				return {
					left: 'calc('+this.catBgLeft+'px / var(--scale-rate))' ,  
					width: 'calc('+this.catBgWidth+'px / var(--scale-rate))' 
				}
			},
			bigProduct() {
				if(this.curProductCat && this.curProductCat.productServiceList.length>0) {
					let arr = JSON.parse(JSON.stringify(this.curProductCat.productServiceList));
					arr.sort( ()=> {
					  return Math.random() - 0.5
					})
					return arr[0];
				}
				return undefined;
			},
			smallProductList() {
				if(this.curProductCat && this.curProductCat.productServiceList.length>1) { 
					return this.curProductCat.productServiceList.filter(it => it.id != this.bigProduct.id);
				}
				return undefined;
			}
		},
		mounted() {
			
		},
		methods: {
			getSwiperProgress(idx) {
				return this.swiperProgress[idx] || '0%';
			},
			onclickCatClick(idx) {
				this.productCatIdx = idx;
				const rect = this.catDomRects[idx];
				this.catBgLeft = rect.left - this.productLstRect.left;
				this.catBgWidth = rect.width;
			},
			onProductCatLoaded() {
				const productLstDom = document.querySelector(".product-list");
				this.productLstRect = productLstDom.getBoundingClientRect();
				this.catDoms = document.querySelectorAll(".product-list .cat-list-container .menu-item");
				for(let i = 0; i < this.catDoms.length; i ++) {
					this.$set(this.catDomRects, i, this.catDoms[i].getBoundingClientRect());
				}
				this.onclickCatClick(this.productCatIdx);
			},
			handleTouchStart(e) {
				if (e.touches.length == 1) {
					//设置触摸起始点水平方向位置
					this.swiper.touchStartX = e.touches[0].clientX;
				}
			},
			handleTouchEnd(e) {
				if (e.changedTouches.length == 1) {
					//手指移动结束后水平位置
					var endX = e.changedTouches[0].clientX;
					let diff = endX - this.swiper.touchStartX;
					if (Math.abs(diff) > 50) {
						if (diff > 0) {
							this.throttle(this.prevFun);
						} else {
							this.throttle(this.nextFun);
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.view-index-v {
		width: 100%;
		padding: 0 calc(52px * var(--scale-rate));

		.rotation-poster {
			width: 100%;
			height: 0;
			padding-top: 100%;
			position: relative;
			overflow: hidden;

			.container {
				width: calc(100% * var(--img-count));
				height: 100%;
				top: 0;
				overflow: hidden;
				position: absolute;
				/* 开启弹性盒，让图片横向排列 */
				display: flex;
				animation: run 10s ease infinite;
			}

			.img-item {
				width: calc(100% / var(--img-count));
				height: 100%;
				cursor: pointer;
				position: relative;
				
				video {
					width: 100%;
					height: 100%;
				}
				
				.link-txt {
					position: absolute;
					bottom: calc(60px * var(--scale-rate));
					padding-left: 20px;
					font-size: 43px;
					color: #FFFFFF;
					background-color: rgba(230, 230, 230, 31%);
					backdrop-filter: blur(5px);
					width: calc(100% / var(--scale-rate));
					line-height: 2;
					transform: scale(var(--scale-rate));
					transform-origin: 0 100%;
				}
			}
			div .img-item {
				background-size: cover;
				background-color: #000000;
			}

			.swiper-wrapper {
				position: absolute;
				width: 100%;
				height: calc(80px * var(--scale-rate));
				left: 0;
				bottom: 0;
				z-index: 99;

				.swiper-item {
					max-width: calc(158px * var(--scale-rate));
					width: calc(100% / var(--img-count));
					margin: 0 calc(10px * var(--scale-rate));
					padding: calc(20px * var(--scale-rate)) 0;
					cursor: pointer;
					.swiper-item-inner {
						background-color: #FFFFFF;
						height: calc(5px * var(--scale-rate));
						width: 100%;
					}
					.progress {
						width: 0%;
						height: 100%;
						background-color: rgb(122, 122, 122);
						
						&.actived {
							transition: width 4s ease-in-out;
						}
					}
				}
			}

			.menu-list {
				position: absolute;
				z-index: 99;
				left: 0;
				bottom: calc(80px * var(--scale-rate));
				width: calc(100% / var(--scale-rate));
				height: 239px;
				background-color: rgba(230, 230, 230, 31%);
				overflow-y: auto;
				transform: scale(var(--scale-rate));
				transform-origin: 0 100%;
				backdrop-filter: blur(5px);

				&::-webkit-scrollbar {
					display: none;
				}

				.menu-item {
					position: absolute;
					cursor: pointer;
					line-height: 1.2;
					width: 282px;
					height: 100%;
					margin: auto 20px;
					font-size: 43px;
					color: #FFFFFF;
					font-weight: lighter;
					z-index: 99;

					&.actived {
						font-weight: normal;
					}

					.menu-item-txt {
						width: 100%;
					}
				}

				.menu-item-bg {
					background: linear-gradient(to right, rgba(158, 158, 158, 1), rgba(255, 255, 255, .1));
					top: 0;
					width: 322px;
					height: 100%;
					object-fit: fill;
					position: absolute;
					z-index: 0;
					transition: 0.2s;
					z-index: 0;
				}
			}
		}
		
		.product-list {
			margin-top: calc(30px * var(--scale-rate));
			.product-caption {
				height: calc(150px * var(--scale-rate));
				
				.list-icon {
					width: calc(38px * var(--scale-rate));
					height: calc(38px * var(--scale-rate));
					margin-left: calc(7px * var(--scale-rate));
				}
				
				.caption {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: flex-start;
					margin-left: 14px;
					//margin-top: 10px;
					line-height: 1;
					transform: scale(var(--scale-rate));
					transform-origin: left center;
				
					.zh {
						font-size: 34px;
						letter-spacing: 1.4px;
						font-weight: bold;
					}
				
					.en {
						font-size: 14px;
						letter-spacing: -0.8px;
						margin-top: 2px;
						margin-left: 20px;
					}
				}
			}
			
			.main-containner {
				width: 100%;
				display: flex;
				flex-direction: column;
				.cat-list-container {
					width: 100%;
					height: calc(68px * var(--scale-rate));
					overflow-x: auto;
					overflow-y: hidden;
					&::-webkit-scrollbar {
						display: none;
					}
				}
				.cat-list {
					display: flex;
					flex-direction: row;
					transform: scale(var(--scale-rate));
					transform-origin: 0 0;
					position: relative;
					
					.menu-item {
						font-size: 31px;
						white-space: nowrap;
						padding: 0 55px;
						height: 68px;
						line-height: 68px;
					}
					
					.menu-item-bg {
						position: absolute;
						top: 0;
						left: 0;
						width: 328px;
						height: 68px;
						transition: 0.2s;
						background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(27, 20, 100, .1) 20%,
							rgba(27, 20, 100, .4) 50%, rgba(27, 20, 100, .1) 80%, rgba(255, 255, 255, 0) 100%);
					}
				}
				.product-list-container {
					width: 100%;
					margin: calc(75px * var(--scale-rate)) 0;
					align-items: flex-start;
					.product-item {
						//width: 100%;
						//height: 100%;
						position: relative;
						.product-img {
							position: absolute;
							left: 0;
							top: 0;
							width: 100%;
							height: 100%;
							object-fit: fill;
						}
						.inf-container {
							width: calc(100% / var(--scale-rate));
							height: 130px;
							background-color: rgba(58, 58, 61, 0.58);
							position: absolute;
							bottom: calc(16px * var(--scale-rate));
							color: #FFFFFF;
							transform: scale(var(--scale-rate));
							transform-origin: 0 100%;
							padding-left: 40px;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: flex-start;
							.name {
								font-size: 38px;
								width: 100%;
							}
							.profile {
								font-size: 22px;
								width: 100%;
							}
						}
					}
					.big-product {
						width: 75%;
						height: 0;
						padding-top: 50%;
					}
					.small-product-list {
						width: 25%;
						padding-left: calc(8px * var(--scale-rate));
						.sall-product-item {
							width: 100%;
							height: 0;
							padding-top: 66.6666667%;
							margin-bottom: calc(8px * var(--scale-rate));
							&:last-child {
								margin-bottom: 0;
							}
							&.product-item {
								.inf-container {
									height: 50px;
									bottom: calc(6px * var(--scale-rate));
									padding-left: 10px;
									.name {
										font-size: 14px;
									}
									.profile {
										font-size: 8px;
									}
								}
							}
						}
					}
				}
			}
		}
		
	}
</style>